import { render, staticRenderFns } from "./VoiceButtonDropdown.vue?vue&type=template&id=676c9176&"
import script from "./VoiceButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./VoiceButtonDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports